import React from 'react'
import { isFlagOn, K12_CORE_CURRICULUM_SERVICE_FLAG } from 'utils/featureFlags'
import {
  RouteContentGetter,
  RouteContentType,
} from 'layers/content/v2/Hocs/RouteContentGetter'
import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'

export { RouteContentType }

/**
 * Flag-switched HOC factory. Returns a component that checks the flag
 * at render time, delegating to v3 CurriculumRouteContentGetter when on
 * or the original v2 RouteContentGetter when off.
 *
 * Drop-in replacement for RouteContentGetter — same signature.
 *
 * Remaining static pages (section landings, MS advisory activities, K5
 * activityList, HS SEAs) render through PagesV2 / FlaggedRouteContentGetter
 * and follow the K12 core curriculum-service flag.
 */
export function FlaggedRouteContentGetter(Component, options) {
  const CurriculumWrapped = CurriculumRouteContentGetter(Component, options)
  const LegacyWrapped = RouteContentGetter(Component, options)

  function FlaggedComponent(props) {
    if (isFlagOn([K12_CORE_CURRICULUM_SERVICE_FLAG])) {
      return <CurriculumWrapped {...props} />
    }
    return <LegacyWrapped {...props} />
  }

  FlaggedComponent.displayName = `FlaggedRouteContentGetter(${Component.displayName ||
    Component.name ||
    'Component'})`

  return FlaggedComponent
}
